/** Logo hợp tác xã dùng cho các bản in dựng phía client. Dùng đúng ảnh mà phiếu
 *  đóng gói bên server nhúng (`server/internal/usecase/invoice/logo.png`, bản
 *  sao ở `public/logo-export.png`) để hai chứng từ in ra cùng một con dấu.
 *
 *  Đọc thành data URL vì `printReceiptHtml` chỉ chờ 100ms trước khi gọi in —
 *  ảnh tải qua mạng thường không kịp.
 *
 *  Kết quả được nhớ ở cấp module: một trang danh sách có hàng chục nút in, để
 *  mỗi nút tự tải thì trình duyệt phải giải mã cùng một ảnh hàng chục lần. */
let pending: Promise<string | undefined> | null = null

export function loadCompanyLogoDataUrl(): Promise<string | undefined> {
    if (pending) return pending
    pending = fetch('/logo-export.png')
        .then((res) => res.blob())
        .then(
            (blob) =>
                new Promise<string | undefined>((resolve) => {
                    const reader = new FileReader()
                    reader.onloadend = () =>
                        resolve(
                            typeof reader.result === 'string'
                                ? reader.result
                                : undefined,
                        )
                    reader.onerror = () => resolve(undefined)
                    reader.readAsDataURL(blob)
                }),
        )
        .catch(() => undefined)
    return pending
}

/** Chỉ dùng trong test — xoá bộ nhớ tạm giữa các ca. */
export function resetCompanyLogoCache(): void {
    pending = null
}
